import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailPersonalInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.2)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M18.3333 4.99967C18.3333 4.08301 17.5833 3.33301 16.6667 3.33301H3.33333C2.41667 3.33301 1.66667 4.08301 1.66667 4.99967M18.3333 4.99967V14.9997C18.3333 15.9163 17.5833 16.6663 16.6667 16.6663H3.33333C2.41667 16.6663 1.66667 15.9163 1.66667 14.9997V4.99967M18.3333 4.99967L10 10.833L1.66667 4.99967",
			stroke: "currentColor",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgMailPersonalInfo);
export default ForwardRef;
